export { default } from "./useMetadataSearchQuery";
